module.exports = __webpack_public_path__ + "hotel-restaurant.9ae344dec6eb53d8babe.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/INMOGR/Desktop/Angular Project/src/assets/fonts/line-icons-pro/hotel-restaurant/webfont/hotel-restaurant.eot
// module id = ../../../../../src/assets/fonts/line-icons-pro/hotel-restaurant/webfont/hotel-restaurant.eot
// module chunks = styles